import { API_URL, buildHeaders, handleResponse } from './apiClient';

const BASE_URL = `${API_URL}/steel/purchases`;

export const fetchSteelPurchases = async (token) => {
  const response = await fetch(BASE_URL, {
    method: 'GET',
    headers: buildHeaders(token),
  });

  return handleResponse(response, 'Kunne ikke laste stålinnkjøp.');
};

export const createSteelPurchase = async (payload, token) => {
  const response = await fetch(BASE_URL, {
    method: 'POST',
    headers: buildHeaders(token),
    body: JSON.stringify(payload),
  });

  return handleResponse(response, 'Kunne ikke registrere innkjøp.');
};

export const updateSteelPurchase = async (id, payload, token) => {
  const response = await fetch(`${BASE_URL}/${id}`, {
    method: 'PUT',
    headers: buildHeaders(token),
    body: JSON.stringify(payload),
  });

  return handleResponse(response, 'Kunne ikke oppdatere innkjøp.');
};

export const deleteSteelPurchase = async (id, token) => {
  const response = await fetch(`${BASE_URL}/${id}`, {
    method: 'DELETE',
    headers: buildHeaders(token),
  });

  return handleResponse(response, 'Kunne ikke slette innkjøp.');
};

export const fetchPurchaseSummary = async (token) => {
  const response = await fetch(`${BASE_URL}/summary`, {
    method: 'GET',
    headers: buildHeaders(token),
  });

  return handleResponse(response, 'Kunne ikke hente oppsummering.');
};
